/**
 * Modules dependencies
 */
const Validation = require('frontend-validation');
const toCamelCase = require('./utils');

/**
 * Validate zipcode
 */
module.exports = {
  validateZipCode: function validateZipCode(zipcode, translations, validations) {
    const trimmedZipcode = typeof zipcode === 'string' ? zipcode.trim() : zipcode;
    const validateZipcode = Validation.run(trimmedZipcode, {
      errorMessages: {
        ZIPCODE_REQUIRED: translations.required,
        ZIPCODE_ONLY_NUMBERS: translations.onlyNumbersZipCode,
        ZIPCODE_MINLENGTH: translations.minLengthZipCode,
        ZIPCODE_MAXLENGTH: translations.minLengthZipCode,
      },
      validators: [
        {
          name: 'required',
          value: true,
          error_message: 'ZIPCODE_REQUIRED',
        },
        {
          name: 'pattern',
          value: validations.pattern || '[0-9]+',
          error_message: 'ZIPCODE_ONLY_NUMBERS',
        },
        {
          name: 'minLength',
          value: validations.minLength || 0,
          error_message: 'ZIPCODE_MINLENGTH',
        },
        {
          name: 'maxLength',
          value: validations.maxLength || 9,
          error_message: 'ZIPCODE_MAXLENGTH',
        },
      ],
    });
    return validateZipcode ? toCamelCase(validateZipcode) : validateZipcode;
  },
  validateStatesCities: function validateStatesCities(value, translations) {
    const validateStates = Validation.run(value, {
      errorMessages: {
        REQUIRED: translations.required,
      },
      validators: [
        {
          name: 'required',
          value: true,
          error_message: 'REQUIRED',
        },
        {
          name: 'minLength',
          value: 2,
          error_message: 'REQUIRED',
        },
      ],
    });
    return validateStates ? toCamelCase(validateStates) : validateStates;
  },

  track(principalPath, secondaryPath, eventData = {}, dimensions = {}) {
    if (window.meli_ga) {
      window.meli_ga(
        'send',
        'event',
        'CURRENT_LOCATION',
        secondaryPath.toUpperCase(),
        principalPath.toUpperCase(),
        dimensions,
      );
    }
    if (window.melidata) {
      window.melidata('cleanAndSend', 'event', {
        path: `/current_location/${principalPath}/${secondaryPath}`,
        event_data: eventData,
        useBeacon: true,
      });
    }
  },

  /**
   * If the array is empty or only have one value and that value is the placeholder option
   */
  checkIsCitiesEmpty(stateCity) {
    return (stateCity.cities.values === null
      || (stateCity.cities.values.length === 1 && stateCity.cities.values[0].id === '0')
    );
  },

  getUrlWithoutTokens(url) {
    if (!url) return '';

    const regexs = [
      /access_token=[^&]+&?/g,
      /accessToken=[^&]+&?/g,
      /go=[^&]+&?/g, // go param can have access_token or accessToken
      /[?&]$/, // ? or & at the end of the url
    ];

    return regexs.reduce((acc, regex) => acc.replace(regex, ''), url);
  },
};
